import { all, fork } from 'redux-saga/effects';
import authWatcher from './Auth/Auth.saga';
import timelineWatcher from './Timeline/Timeline.saga';
import timerWatcher from './Timer/Timer.saga';
import teamWatcher from './Team/Team.saga';
import memberWatcher from './Member/Member.saga';
import memberSessionsWatcher from './Member/MemberSessions.saga';
import regularizationWatcher from './Regularization/Regularization.saga';
import leaveWatcher from './Leave/Leave.saga';
import pocWatcher from './Poc/Poc.saga';
import invitationWatcher from './Invitation/Invitation.saga';
import manageTeamsWatcher from './ManageTeams/ManageTeams.saga';
import planFeaturesWatcher from './PlanFeatures/PlanFeatures.saga';
export default function* rootSaga() {
  yield all([
    fork(authWatcher),
    fork(teamWatcher),
    fork(memberWatcher),
    fork(memberSessionsWatcher),
    fork(timelineWatcher),
    fork(invitationWatcher),
    fork(manageTeamsWatcher),
    fork(pocWatcher),
    fork(timerWatcher),
    fork(regularizationWatcher),
    fork(leaveWatcher),
    fork(planFeaturesWatcher),
  ]);
}
